import type {AuditDataAssetsV2Body} from './AuditDataAssetsV2Body';

export type AuditAssetsUploadV2RequestBody = {
  auditId: string;
  assets: Array<AuditDataAssetsV2Body>;
};
